/* eslint-disable */

import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react-lite';
import { observable, reaction, toJS } from 'mobx';

import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Toolbar } from 'polotno/toolbar/toolbar';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';
import {
  SidePanel,
  SectionTab,
  TextSection,
  UploadSection,
} from 'polotno/side-panel';
import { Workspace } from 'polotno/canvas/workspace';
import createStore from 'polotno/model/store';
import VscPreview from '@meronex/icons/vsc/VscPreview';
import { Button, EditableText } from '@blueprintjs/core';
import styled from 'polotno/utils/styled';

import {
  unstable_useHtmlTextRender,
  unstable_registerNextDomDrop,
  unstable_setForceTextFit,
  unstable_setTextVerticalResizeEnabled,
} from 'polotno/config';

unstable_useHtmlTextRender(true);
// unstable_setTextVerticalResizeEnabled(true);

const Container = styled('div')`
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;

  .bp3-dark & .polotno-text-preview-plain {
    filter: invert(1);
  }
`;

const DragButton = ({ onSelect, ...props }) => {
  return (
    <Button
      {...props}
      draggable
      className="polotno-close-panel"
      onClick={() => onSelect()}
      onDragStart={() => {
        unstable_registerNextDomDrop(({ x, y }) => {
          onSelect({ x, y });
        });
      }}
      onDragEnd={(e) => {
        unstable_registerNextDomDrop(null);
      }}
    />
  );
};

export const TextPanel = observer(({ store }) => {
  React.useEffect(() => {
    store.loadFont('Roboto');
  }, []);

  const addText = (attrs) => {
    const width = attrs.width || store.width / 2;

    const x = attrs?.x || store.width / 6;
    const y = (attrs?.y || store.height / 2) - attrs.fontSize / 2;

    const element = store.activePage?.addElement({
      type: 'text',
      fontFamily: 'Roboto',
      ...attrs,
      x,
      y,
      width: width,
    });
    element?.toggleEditMode(true);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Container>
        <DragButton
          style={{
            marginBottom: '5px',
            width: '100%',
            fontSize: '14px',
            fontFamily: 'Roboto',
          }}
          onSelect={(pos) => {
            addText({
              ...pos,
              fontSize: 30,
              text: 'Add your text and mention the {COMPANY_NAME}',
              align: 'left',
              fontFamily: 'Roboto',
              width: 700,
            });
          }}
        >
          {'Add text to the design'}
        </DragButton>
      </Container>
    </div>
  );
});

const companiesList = observable([]);

const resetName = (store) => {
  unstable_setForceTextFit(false);
  store.activePage.children.forEach((child) => {
    if (child.custom?.oldText) {
      child.set({
        text: child.custom?.oldText,
        height: child.custom?.oldHeight || child.height,
        fontSize: child.custom?.oldFontSize || child.fontSize,
        custom: {
          ...child.custom,
          oldText: null,
          oldHeight: null,
          oldFontSize: null,
        },
      });
    }
  });
};

const replaceName = (store, name) => {
  unstable_setForceTextFit(true);
  store.activePage.children.forEach(async (child) => {
    if (child.type !== 'text') {
      return;
    }
    const oldText = child.custom?.oldText || child.text;
    if (oldText.indexOf('{COMPANY_NAME}') === -1) {
      return;
    }
    child.set({
      text: oldText.replace('{COMPANY_NAME}', name),
      custom: {
        oldText,
        oldFontSize: child.custom?.oldFontSize || child.fontSize,
        oldHeight: child.custom?.oldHeight || child.height,
      },
    });
    return;
  });
};

// define the new custom section
const Preview = {
  name: 'preview',
  Tab: (props) => (
    <SectionTab name="Previews" {...props}>
      <VscPreview />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    return (
      <div
        onMouseLeave={() => {
          resetName(store);
        }}
        style={{ overflow: 'auto', height: '100%' }}
      >
        <p>Preview as:</p>
        {companiesList.map((name, index) => {
          return (
            <div
              key={index}
              style={{
                width: '100%',
                marginBottom: '10px',
                textAlign: 'left',
                padding: '10px',
                boxShadow: '0px 0px 2px rgba(0,0,0,0.5)',
                borderRadius: '3px',
                backgroundColor: 'rgba(0,0,0,0.05)',
                cursor: 'pointer',
              }}
              onMouseEnter={() => {
                replaceName(store, name);
              }}
              onMouseLeave={() => {
                resetName(store);
              }}
            >
              <EditableText
                value={name}
                onChange={(value) => {
                  companiesList[index] = value;
                  replaceName(value);
                }}
              ></EditableText>
            </div>
          );
        })}
      </div>
    );
  }),
};

TextSection.Panel = TextPanel;
// add new section

const addStyle = (link) => {
  var ss = document.createElement('link');
  ss.type = 'text/css';
  ss.rel = 'stylesheet';
  ss.href = link;
  document.getElementsByTagName('head')[0].appendChild(ss);
};

addStyle('https://unpkg.com/@blueprintjs/icons@^4/lib/css/blueprint-icons.css');
addStyle('https://unpkg.com/@blueprintjs/core@^4/lib/css/blueprint.css');
addStyle(
  'https://unpkg.com/@blueprintjs/popover2@1/lib/css/blueprint-popover2.css'
);

const ActionControls = ({ store }) => {
  return (
    <div>
      <Button
        minimal
        onClick={() => {
          const element = store.activePage?.addElement({
            type: 'text',
            fontSize: 30,
            text: 'Add your text and mention the {COMPANY_NAME}',
            align: 'left',
            width: 700,
          });
        }}
      >
        Add Text
      </Button>
      <Button
        onClick={() => {
          store.saveAsImage({ fileName: 'advertaze.png' });
        }}
        minimal
      >
        Download
      </Button>
    </div>
  );
};

export const DesignEditor = ({
  API_KEY,
  companies,
  companyName,
  style,
  json,
  onChange,
  onCompaniesListChange,
  backgroundImage,
}) => {
  const store = React.useMemo(() => {
    const s = createStore({ key: API_KEY });
    s.setSize(1200, 628);
    s.addPage();
    s.on('change', () => {
      // check if we have preview mode:
      const previewPage = store.pages.find((page) => {
        return page.children.find((child) => child.custom?.oldText);
      });
      if (!previewPage && onChange) {
        onChange(store.toJSON());
      }
    });
    return s;
  }, []);

  React.useEffect(() => {
    if (companies) {
      companiesList.replace(companies);
    }
  }, [companies]);

  React.useEffect(() => {
    if (!json) {
      return;
    }
    const changed = JSON.stringify(json) !== JSON.stringify(store.toJSON());
    if (changed) {
      store.loadJSON(json);
    }
  }, [json]);

  React.useEffect(() => {
    reaction(
      () => toJS(companiesList),
      (newList) => {
        if (onCompaniesListChange) {
          onCompaniesListChange(newList);
        }
      }
    );
  }, []);

  React.useEffect(() => {
    if (store.activePage) {
      store.activePage.set({
        background: backgroundImage,
      });
    }
  }, [backgroundImage]);

  React.useEffect(() => {
    if (companyName) {
      replaceName(store, companyName);
    } else {
      resetName(store);
    }
  }, [companyName]);

  const sections = [];

  if (companies && companies.length) {
    sections.push(Preview, UploadSection, TextSection);
  }

  return (
    <div style={style || { width: '100vw', height: '100vh' }}>
      <PolotnoContainer style={{ width: '100%', height: '100%' }}>
        {!!sections.length && (
          <SidePanelWrap>
            <SidePanel
              store={store}
              sections={sections}
              defaultSection="upload"
            />
          </SidePanelWrap>
        )}
        <WorkspaceWrap>
          <Toolbar
            store={store}
            components={{
              ActionControls,
            }}
          />
          <Workspace store={store} components={{ PageControls: () => null }} />
          <ZoomButtons store={store} />
        </WorkspaceWrap>
      </PolotnoContainer>
    </div>
  );
};
